var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.11 5.45a.822.822 0 0 0-.61-.25h-.29V4.03c0-1.11-.39-2.06-1.18-2.85C7.24.39 6.29 0 5.18 0S3.12.39 2.33 1.18c-.79.79-1.18 1.74-1.18 2.85V5.2H.86c-.24 0-.44.08-.61.25-.17.17-.25.37-.25.61v5.18c0 .24.08.44.25.61.17.17.37.25.61.25H9.5c.24 0 .44-.08.61-.25.17-.17.25-.37.25-.61V6.06c0-.24-.08-.44-.25-.61zM2.88 5.2V4.03c0-.64.22-1.18.67-1.63.45-.45.99-.67 1.63-.67.64 0 1.18.22 1.63.67.45.45.67.99.67 1.63V5.2h-4.6z",
    fill: "#0A68FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h10.36v12.11H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedIcon);
export default ForwardRef;